import { Range } from '../../entities/range.model';
import { Table } from '../../entities/table.model';
import { Field } from '../../entities/field.model';


export class FieldsTable extends Table<{ [fieldId: number]: Field; }> {
    private taxonomyFieldsCache: { [taxonomyId: number]: number[]; } = {};
    private fieldIds: number[] = [];

    constructor(
        range: Range) {
        super(range, false, {});
    }

    add(field: Field): boolean {
        if (!this.exists(field.id)) {
            if (this.containsData) {
                this.range.rowCount++;
            } else {
                this.containsData = true;
            }

            this.cache[field.id] = field;
            this.fieldIds.push(field.id);

            if (field.containsTaxonomyId) {
                this.addTaxonomyField(field.taxonomyId, field.id);
            }

            return true;
        }

        return false;
    }

    remove(fieldId: number): boolean {
        if (this.exists(fieldId)) {
            const field = this.cache[fieldId];

            if (field.containsTaxonomyId) {
                this.removeTaxonomyField(field.taxonomyId, fieldId);
            }

            delete this.cache[fieldId];
            this.fieldIds.splice(this.fieldIds.indexOf(fieldId), 1);

            if (this.range.rowCount == 2 /* header + one row */) {
                this.containsData = false;
            } else {
                this.range.rowCount--;
            }

            return true;
        }

        return false;
    }

    getField(fieldId: number): Field {
        return this.cache[fieldId];
    }

    getTaxonomyFieldIds(taxonomyId: number): number[] {
        const taxonomyFieldIds = this.taxonomyFieldsCache[taxonomyId];
        return taxonomyFieldIds ? [...taxonomyFieldIds] : undefined;
    }

    getRowPosition(fieldId: number): number {
        if (this.exists(fieldId)) {
            return this.fieldIds.indexOf(fieldId);
        }

        return -1;
    }

    exists(fieldId: number): boolean {
        return this.cache.hasOwnProperty(fieldId);
    }

    private addTaxonomyField(taxonomyId: number, fieldId: number): void {
        const taxonomyFields = this.taxonomyFieldsCache[taxonomyId];

        if (!taxonomyFields) {
            this.taxonomyFieldsCache[taxonomyId] = [fieldId];
        } else if (taxonomyFields.indexOf(fieldId) === -1) {
            taxonomyFields.push(fieldId);
        }
    }

    private removeTaxonomyField(taxonomyId: number, fieldId: number): void {
        const taxonomyFields = this.taxonomyFieldsCache[taxonomyId];

        taxonomyFields.splice(taxonomyFields.indexOf(fieldId), 1);

        if (taxonomyFields.length === 0) {
            delete this.taxonomyFieldsCache[taxonomyId];
        }
    }
}